import { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { Textarea } from "./ui/textarea";

interface EditSceneModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: { scene?: string }) => void;
  initialScene?: string;
}

export function EditSceneModal({ isOpen, onClose, onSave, initialScene }: EditSceneModalProps) {
  const [scene, setScene] = useState<string>(initialScene ?? "");

  useEffect(() => {
    setScene(initialScene ?? "");
  }, [initialScene]);

  const handleSave = () => {
    onSave({ scene: scene.length > 0 ? scene : undefined });
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>シーンの編集</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Textarea
              id="scene"
              value={scene}
              onChange={(e) => setScene(e.target.value)}
              rows={10}
              className="w-full"
            />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={onClose} variant="outline">
            キャンセル
          </Button>
          <Button onClick={handleSave}>保存</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
